module.exports = __webpack_public_path__ + "static/media/Lato-v15-latin-600.d0acb430.woff2";